<template>
    <QDialog
        v-model="opened"
        @hide="close"
    >
        <QCard class="flex column Card">
            <QBar class="bg-primary text-white">
                <div class="row items-center no-wrap">
                    <div class="text-subtitle1 text-weight-medium">
                        {{ $t('booster.d2t.analysisReport') }}
                    </div>
                    <QIcon
                        class="copy-button q-ml-sm"
                        name="content_copy"
                        color="white"
                        size="20px"
                        @click="copyToClipboard"
                        @mouseover="onMouseOver"
                        @focus="onMouseOver"
                        @mouseleave="onMouseLeave"
                        @blur="onMouseLeave"
                    />
                    <QTooltip
                        anchor="center right"
                        self="center start"
                    >
                        {{ tooltipMessage }}
                    </QTooltip>
                </div>
                <QSpace />
                <QBtn
                    v-close-popup
                    dense
                    flat
                    color="white"
                    icon="close"
                    @click="close"
                />
            </QBar>
            <q-card-section class="q-px-lg">
                <div
                    class="AnalysisReport"
                >
                    <div v-html="analysisReport" />
                </div>
            </q-card-section>
        </QCard>
    </QDialog>
</template>
<script>
export default {
    name: 'AnalysisReportModal',
    components: {},
    inject: ['App'],
    emits: ['save'],
    data() {
        return {
            opened: false,
            analysisReport: '',
            pureAnalysisReport: '',
            tooltipMessage: this.$t('booster.d2t.copyToClipboard'),
            isCopied: false,
        }
    },
    methods: {
        open(params) {
            this.reset()
            this.analysisReport = this.App.numberLocationFormat(params.analysisReport, false, true)
            this.opened = true
        },
        close() {
            this.opened = false
        },
        reset() {
            this.tooltipMessage = this.$t('booster.d2t.copyToClipboard')
            this.isCopied = false
        },
        copyToClipboard() {
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = this.analysisReport
            navigator.clipboard.writeText(tempDiv.innerText).then(() => {
                this.tooltipMessage = this.$t('booster.d2t.copied')
                this.isCopied = true
            })
        },
        onMouseOver() {
            if (!this.isCopied) {
                this.tooltipMessage = this.$t('booster.d2t.copyToClipboard')
            }
        },
        onMouseLeave() {
            setTimeout(() => {
                this.isCopied = false
                this.tooltipMessage = this.$t('booster.d2t.copyToClipboard')
            }, 200)
        },
    },
}
</script>
<style scoped lang="scss">

.q-dialog__inner--minimized > div {
    max-width: 800px;
}
.Card {
    overflow:hidden;
    flex-wrap:nowrap;
}
.Header {
    position:sticky;
    padding-bottom:0px;
}
.Body {
    overflow-y:auto;
    padding-top:0px;
}
.AnalysisReport {
    margin-top: 40px;
    margin-bottom: 20px;
}
.copy-button {
    color: $primary;
    cursor: pointer;
}
</style>
